import { Directive, Input, HostBinding, ElementRef } from '@angular/core';
import { SubscriptMessage } from './subscript-message';

let uniqueId = 1;
@Directive({
  selector: '[pgError], [gritError]',
  providers: [
    {
      provide: SubscriptMessage,
      useExisting: PgErrorDirective,
      multi: true,
    },
  ],
})
export class PgErrorDirective implements SubscriptMessage {
  @HostBinding('class') _classList =
    'pg-error pg-subscript-message grit-error grit-subscript-message';

  @Input() for: string;

  @Input() controlName: string;

  id = uniqueId++;

  readonly type;

  constructor(public elementRef: ElementRef) {
    this.type = 'error';
  }
}
